import categoryReducer from './reducers';
export { default as categoryOperations } from './operations';
export { default as categoryTypes } from './types';
export default categoryReducer;